import React from 'react';

import ChatWindowMessages from './ChatWindowMessages';
import ChatWindowHeader from './ChatWindowHeader';
import ChatWindowFooter from './ChatWindowFooter';

const ChatWindowInner = React.memo(({ messages }: any) => {
  return (
    <div
      css={(theme: Theme) => ({
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        marginTop: theme.widget.padding,
        boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)',
        borderRadius: '4px',
        background: 'white',
      })}
    >
      <ChatWindowHeader />
      <ChatWindowMessages messages={messages} />
      <ChatWindowFooter />
    </div>
  );
});

export default ChatWindowInner;
